export var BillingInterval;
(function (BillingInterval) {
    BillingInterval["month"] = "month";
    BillingInterval["year"] = "year";
})(BillingInterval || (BillingInterval = {}));
export const upgradeReasons = {
    emailSupport: "email-support",
    multistep: "multistep",
    paths: "paths",
    premium: "premium",
    premiumLimit: "premium-limit",
    taskLimit: "tasks",
    taskLimitLow: "tasks-low",
    zapLimit: "live-zaps",
};
export const trialExtensionReasons = {
    emailSupport: "email-support",
    multistep: "multistep",
    paths: "paths",
    premium: "premium",
    premiumLimit: "premium-limit",
    taskLimit: "tasks",
    unknown: "unknown",
    zapLimit: "live-zaps",
};

// @zapier/upsells@8.0.3 (1de7a616e)
